/* tslint:disable */
/* eslint-disable */
export enum PartnerGatewayEnum {
  ExpandIt = 'ExpandIt',
  Gastech = 'Gastech'
}
